<template>
    <div class="flex h-full flex-col justify-center text-center">
        <div class="mb-4 text-8xl font-bold text-gray-900">
            {{ displayedTitle }}
        </div>
        <p
            class="line-height-3 mx-auto mb-5 mt-0 max-w-md text-xl font-medium text-gray-700"
        >
            {{ displayedText }}
        </p>
        <nuxt-link
            :to="facilityHome"
            class="mt-4 text-gray-700"
        >
            <prime-button>{{ t('notFound.backToHome') }}</prime-button>
        </nuxt-link>
    </div>
</template>

<script setup lang="ts">
import PrimeButton from 'primevue/button'
import { useActiveFacility } from '~/composables/use-active-facility'
import { computed } from 'vue'
import { useRouteLink } from '~/composables/routing'
import { useI18n } from 'vue-i18n'
import { useNoSearchIndexing } from '~/composables/use-search-indexing'

// Missing or unavailable offerings must not inherit their public route's search eligibility.
useNoSearchIndexing()

const props = defineProps<{
    title?: string
    reason?: string
}>()

const activeFacility = useActiveFacility()
const { facilityHomeLink } = useRouteLink()
const { t } = useI18n({ useScope: 'global' })
const facilityHome = computed(() => facilityHomeLink(activeFacility.value.slug))

const displayedTitle = computed(() => {
    return props.title ?? t('oops')
})

const displayedText = computed(() => {
    return props.reason ?? t('notFound.nothingHere')
})
</script>
